import { Link, SpaRounded } from '@mui/icons-material';
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom';

function MemberShip() {
  const navigate = useHistory();
  const [membershipData, setMembershipData] = useState([]);
  useEffect(() => {
    axios.get("https://portal.fitstreak.club/api/api/membership")
      .then((response) => {
        console.log("this is response", response.data)
        setMembershipData(response.data)
      })
      .catch((error) => {
        console.log("errors", error.message)
      })
  }, [])
  const [gender, setGender] = useState("male");
  const [planType, setPlanType] = useState("alpha");
  const [description, setDescription] = useState("Our Student Membership Plan is designed to help you stay healthy and active without breaking the bank. Enjoy access to top-notch facilities, expert guidance, and flexible timings to fit your busy schedule. Stay fit while you focus on your studies!");
  const [month, setMonth] = useState(1)
  const [planData, setPlanData] = useState([])
  const MarkedSvg = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 30 30"
      className="mr-2"
    >
      <path d="M0 0h30v30H0z" fill="none" />
      <path
        d="m10.254 19.378-4.345-4.591a1.176 1.176 0 0 0-1.738 0 1.343 1.343 0 0 0 0 1.837l5.2 5.5a1.19 1.19 0 0 0 1.751 0L24.284 8.228a1.343 1.343 0 0 0 0-1.837 1.176 1.176 0 0 0-1.738 0z"
        transform="translate(1.027 1.093)"
        fill="#bbb"
        stroke="#bbb"
      />
    </svg>
  );
  useEffect(() => {
    if (membershipData && membershipData.length > 0) {
      const filteredPlans = membershipData.filter((data) => data.membershipPlanName === planType && data.memberShipName === "Basic");
      console.log("This is the filtered plan:", filteredPlans);
      setPlanData(filteredPlans);
    }
  }, [membershipData, planType]);

  return (
    <div className='mt-8 md:mt-10 w-full h-auto p-6 md:p-10 aling-center justify-center text-center'>
      <h1 className='text-white font-[700] text-xl sm:text-2xl md:text-3xl '>Membership</h1>
      <p className='text-md sm:text-lg md:text-lg text-center m-auto w-[96%] md:w-[50%]  mt-4 md:mt-6 text-nav_option'>
        Choose a membership plan that fits your lifestyle and goals at Fit Streak.
        Enjoy flexible options, exclusive benefits, and access to top-notch facilities to kickstart your fitness journey.
      </p>
      <div className='aling-center flex w-max m-auto border border-red rounded-[4px] mt-6 cursor-pointer'>
        <div className={`${gender === 'male' ? 'bg-red' : 'bg-inherit'} px-6 py-2  `} onClick={() => setGender('male')}>
          <p className='text-white text-bold text-lg'>male</p>
        </div>
        <div className={`${gender === 'female' ? 'bg-red' : 'bg-inherit'} px-6 py-2 cursor-pointer `} onClick={() => setGender('female')}>
          <p className='text-white text-bold text-lg'>female</p>
        </div>
      </div>
      <div className='flex flex-col md:flex-row p-1 w-[210px] md:w-[100%] lg:w-[95%] xl:w-[80%] 2xl:w-[65%] mt-4 md:mt-6 border border-[#3b3b3b] h-auto m-auto justify-between rounded-[4px]'>
        <div className={`${planType === 'alpha' ? 'bg-[#3b3b3b]' : 'bg-inherit'}  p-2 md:w-[30%] aling-center text-center  rounded-[4px] cursor-pointer `} onClick={() => {
          setPlanType('alpha')
          setDescription('Unleash your inner athlete! The Alpha Membership is tailored for those who demand the best, offering premium facilities, exclusive classes, and priority access to trainers. Take your fitness game to the next level with this elite plan.')
        }}>
          <h1 className='text-md md:text-lg lg:text-xl text-white font-bold mt-[5%]  w-[90%] '>Alpha</h1>
          <p className='text-sm md:text-xs lg:text-sm  text-nav_option  w-[90%]'>Flexible plans for your individual
            fitness journey.</p>
        </div>
        <div className={`${planType === 'couple' ? 'bg-[#3b3b3b]' : 'bg-inherit'}  p-2 md:w-[30%] aling-center text-center rounded-[4px] cursor-pointer`} onClick={() => {
          setPlanType('couple')
          setDescription('Stay fit together! Our Couple Membership is perfect for partners who want to motivate each other and achieve their fitness goals side by side. Enjoy exclusive benefits and discounts designed for two, making fitness a shared journey.')
        }} >
          <h1 className='text-md md:text-lg lg:text-xl text-white font-bold mt-[5%]  w-[90%] '>Couple</h1>
          <p className='text-sm md:text-xs lg:text-sm text-nav_option  w-[90%]'>Train together with our exclusive
            couple plans.</p>
        </div>
        <div className={`${planType === 'family' ? 'bg-[#3b3b3b]' : 'bg-inherit'}  p-2 md:w-[30%] aling-center text-center  rounded-[4px] cursor-pointer `} onClick={() => {
          setPlanType('family')
          setDescription('Fitness for the entire family! With our Family Membership, every member can access the gym and enjoy customized programs for different ages and needs. Make health and wellness afamily affair with special group rates.')
        }}>
          <h1 className='text-md md:text-lg lg:text-xl text-white font-bold mt-[5%]  w-[90%] '>Family</h1>
          <p className='text-sm md:text-xs lg:text-sm text-nav_option  w-[90%]'>Flexible plans for your individual
            fitness journey.</p>
        </div>
        <div className={`${planType === 'student' ? 'bg-[#3b3b3b]' : 'bg-inherit'}  p-2  md:w-[30%] aling-center text-center rounded-[4px] cursor-pointer`} onClick={() => {
          setPlanType('student')
          setDescription("Our Student Membership Plan is designed to help you stay healthy and active without breaking the bank. Enjoy access to top-notch facilities, expert guidance, and flexible timings to fit your busy schedule. Stay fit while you focus on your studies!")
        }} >
          <h1 className='text-md md:text-lg lg:text-xl text-white font-bold mt-[5%] w-[90%]'>Student</h1>
          <p className='text-sm md:text-xs lg:text-sm text-nav_option  w-[90%]'>Affordable plans tailored for
            students to stay fit.</p>
        </div>
        <div className={`${planType === 'hamaryhero' ? 'bg-[#3b3b3b]' : 'bg-inherit'}  p-2 md:w-[30%] aling-center text-center  rounded-[4px] cursor-pointer `} onClick={() => {
          setPlanType("hamaryhero")
          setDescription('A salute to our real-life heroes! Designed exclusively for military personnel, police, security forces, and rescue workers, this membership offers special discounts and perks as a token of our appreciation for your service and dedication.')
        }}>
          <h1 className='text-md md:text-lg lg:text-xl text-white font-bold mt-[5%]  w-[90%] '>Hamary Hero</h1>
          <p className='text-sm md:text-xs lg:text-sm text-nav_option  w-[90%]'>Flexible plans for your individual
            fitness journey.</p>
        </div>
      </div>

      <div className='w-[100%] lg:w-[100%] xl:w-[90%] 2xl:w-[80%] h-auto p-2  py-10 relative rounded-[10px] mt-10 z-10 bg-custom-gradient2  m-auto  aling-center justify-center'>
        <h1 className='text-white font-[700] text-xl sm:text-2xl md:text-3xl mt-4 '>{planType === "hamaryhero" ? "Hamary Hero" : planType.charAt(0).toUpperCase() + planType.slice(1)}
        </h1>
        <p className='text-md sm:text-lg md:text-lg text-center m-auto w-[96%] md:w-[75%]  mt-4 md:mt-6 text-nav_option'>
          {description}
        </p>
        <div className='aling-center flex xxs:flex-col xxs:w-[150px] xxs:text-center w-max xss:w-max  m-auto border border-red rounded-[20px] mt-8 cursor-pointer'>
          <div className={`${month === 1 ? 'bg-red' : 'bg-inherit'} px-3 py-1 md:px-6 md:py-2 rounded-[20px] `} onClick={() => setMonth(1)}>
            <p className='text-white text-bold  text-xs xs:text-base sm:text-lg'>1 Month</p>
          </div>
          <div className={`${month === 3 ? 'bg-red' : 'bg-inherit'} px-3 py-1 md:px-6 md:py-2   rounded-[20px]  `} onClick={() => setMonth(3)}>
            <p className='text-white text-bold  text-xs xs:text-base sm:text-lg'>3 Month</p>
          </div>
          <div className={`${month === 6 ? 'bg-red' : 'bg-inherit'} px-3 py-1 md:px-6 md:py-2   rounded-[20px]  `} onClick={() => setMonth(6)}>
            <p className='text-white text-bold  text-xs xs:text-base sm:text-lg'>6 Month</p>
          </div>
          <div className={`${month === 12 ? 'bg-red' : 'bg-inherit'} px-3 py-1 md:px-6 md:py-2   rounded-[20px]  `} onClick={() => setMonth(12)}>
            <p className='text-white text-bold  text-xs xs:text-base sm:text-lg'>12 Month</p>
          </div>
        </div>
        <div className="h-auto w-[95%]  m-auto mt-8 justify-center 2xl:w-[88%] xxl:w-[75%] aling-center flex flex-col lg:flex-row ">
          {planData.map((data, index) => (
            <div key={data.id} className='w-[300px] xxs:w-[100%] mt-10  m-auto flex p-2 flex-col   md:w-[300px] lg:w-[300px] lg:m-0 pb-10 xl:w-[300px] 2xl:w-[310px]   border border-[#474747] hover:border hover:border-red  bg-[#1c1c1c] h-auto z-0 rounded-[10px] text-center aling-center justify-center '>
              <div className='mt-4 w-[80%] m-auto text-xl text-white decoration-none font-semibold mb-2'>{data.memberShipName}</div>
              <div className='mt-4 w-[80%]  m-auto text-sm text-nav_option decoration-none mb-2 text-left '>{data.memberShipDescription}</div>
              <div className='mt-4 w-max p-1 rounded-[4px] ml-[10%] bg-red text-xs lg:w-max px-2 xxs:text-xs xl:text-sm text-white decoration-none mb-2'>{`the ${data.memberShipName} plan for ${planType} `} </div>
              <div className='mt-4 w-[80%] m-auto text-2xl xss:text-2xl xl:text-3xl font-bold text-white  decoration-none mt-2 mb-2 text-left'>
                {month === 1 && `${Number(data.memberShipAmount).toLocaleString()} Rs`}
                {month === 3 && `${Number(data.threeMonthAmount).toLocaleString()} Rs`}
                {month === 6 && `${Number(data.sixMonthAmount).toLocaleString()} Rs`}
                {month === 12 && `${Number(data.twelveMonthAmount).toLocaleString()} Rs`}

                <span className=' text-base lg:text-base xl:text-lg text-nav_option decoration-none'>
                  /{month === 1 ? "" : month}month
                </span>
              </div>
              {data.benefits.map((feature, index) => (
                <div
                  key={index}
                  className=" w-[80%] m-auto text-sm text-nav_option decoration-none flex items-center mt-2"
                >

                  <span className='flex flex-row jusitify-between text-left'><MarkedSvg />{feature.benefit}</span>

                </div>

              ))}
            </div>
          ))}
        </div>

        {/* <button className='bg-red py-2 px-6 xxs:text-sm  m-auto w-max rounded-[5px] text-white font-bold mt-10' onClick={() => { navigate.push("/joinNow") }} >Join Now</button> */}

      </div>
    </div>
  )
}

export default MemberShip
